module.exports = __webpack_public_path__ + "img/suppressionProduction.a5aa96c6.png";